export default {
  steps: {
    of: 'Paso {current} de {total}',
    title: {
      1: 'Identifica tu pulsera',
      2: 'Comprueba la cantidad reembolsable',
      3: 'Introduce tus datos bancarios'
    }
  },
  refunds: 'Devoluciones',
  actions: {
    accept: 'Aceptar'
  },
  main: {
    start: 'Iniciar proceso de devolución',
    refund_unavailable: 'Proceso de devolución actualmente no disponible.'
  },
  tagId: {
    label: 'ID de la pulsera',
    validate: 'Validar pulsera',
    tag_placement:
      'Puedes encontrar el ID de tu chip en la parte delantera o trasera.',
    id_description: 'Es una cadena de 14 ó 15 números y letras.'
  },
  balance: {
    current: 'Saldo actual',
    comission: 'Gastos de gestión',
    total: 'Reembolso total',
    refund: 'Proceder al reembolso',
    message: {
      not_enough_balance: 'Devolución no disponible. Los gastos de gestión superan el saldo actual.',
      balance_too_large: 'Las devoluciones por encima de {amount} no están automatizadas.'
    }
  },
  bank_data: {
    document: 'Documento',
    name: 'Nombre',
    surname: 'Primer apellido',
    second_surname: 'Segundo apellido',
    phone: 'Número de teléfono',
    email: 'Correo electrónico',
    document_type: 'Tipo',
    confirm_refund: 'Confirmar reembolso de {amount}',
    hint: {
      phone: 'Incluye el código de tu país: +34 666 666 666'
    },
    document_types: {
      NATIONAL_ID_CARD: 'DNI',
      PASSPORT: 'Pasaporte',
      ARG_TAX_DOCUMENT: 'CUIL/CUIT',
      MEXICAN_RFC: 'RFC Mexicano',
      UYU_CI: 'CI Uruguay'
    },
    account_types: {
      IBAN: 'IBAN',
      CBU: 'CBU',
      CLABE: 'CLABE',
      UYU_ACCOUNT: 'UYU Cuenta'
    }
  },
  result: {
    back_to_main: 'Volver a página principal'
  },
  error: {
    not_found: {
      title: '¡Vaya! No hay nada aquí',
      subheading: 'Accede a esta aplicación mediante el enlace proporcionado',
      tag: 'Este chip no ha sido utilizado en este evento'
    },
    500: `Ha ocurrido un error en el servidor. ¡Trabajamos en solucionarlo!`,
    0:
      '¡Oops! Parece que el servidor no está disponible. ¡Vuelve más tarde!',
    bad_request: {
      any: {
        required: 'Obligatorio',
        empty: 'Obligatorio'
      },
      string: {
        base: 'Obligatorio',
        hex: 'ID de chip inválido. Debe tener 14 ó 15 dígitos.',
        invalid_tag: 'ID de chip inválido. Revisa los dígitos introducidos.',
        min: `No tiene la longitud mínima`
      },
      iban: {
        invalid: 'IBAN inválido'
      },
      cbu: {
        invalid: 'CBU inválido'
      },
      clabe: {
        invalid: 'CLABE inválido'
      },
      uyu_account: {
        invalid: 'Longitud incorrecta, deben ser 14 dígitos'
      },
      email: {
        invalid: 'Correo electrónico inválido'
      },
      phone: {
        invalid: 'Número de teléfono inválido. Incluye el código de tu país: +34 666 666 666'
      },
      cuil_cuit: {
        invalid: 'CUIL/CUIT inválido'
      },
      mexican_rfc: {
        invalid: 'RFC inválido'
      },
    }
  },
  message: {
    close: 'Cerrar mensaje'
  },
  decimal_separator: ',',
  warnings: {
    important: 'Importante: ',
    complete_name: 'Se deben cumplimentar el nombre y apellidos del beneficiario al completo, de no ser así podría no efectuarse correctamente la devolución.'
  }
}
